import { CloseOutline18Icon } from "@vygruppen/spor-icon-react";
import { ButtonTextContainer } from "features/CenterContent/shared/Tabs/TabsCenter";
import {
  ActiveTab,
  InActiveTab,
} from "features/CenterContent/shared/Tabs/TabsStyle";
import {
  ReserveBusTab,
  useTabsContext,
} from "features/CenterContent/shared/Tabs/useTabsContext";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CrossButton } from "shared/components/buttons/CrossButton";
import { Text } from "shared/components/Spor";
import * as ROUTES from "shared/utils/routes";

export const ReserveBusTabElement = ({
  reserveBusTabs,
  index,
}: {
  reserveBusTabs: ReserveBusTab;
  index: number;
}) => {
  const { activeIdTabs, setActiveIdTabs } = useTabsContext();
  const { reserveBusId, reserveTabId } = reserveBusTabs;
  const { vehicleUuid } = useParams();
  const navigate = useNavigate();
  const selected = reserveBusId === vehicleUuid;

  const TabElement = selected ? ActiveTab : InActiveTab;
  return (
    <TabElement
      title={`${reserveBusId}`}
      key={index}
      onClick={(event) => {
        event.preventDefault();
        if (reserveBusId) {
          void navigate(
            generatePath(ROUTES.RESERVEBUS, {
              vehicleUuid: reserveBusId,
            }),
          );
        }
      }}
      style={{
        padding: "4px 10px",
        borderRadius: "6px 6px 0px 0px",
      }}
    >
      <ButtonTextContainer>
        <Text variant="sm" margin="auto">
          {reserveTabId || ""}
        </Text>
        <CrossButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (selected) {
              if (activeIdTabs.length === 1) {
                sessionStorage.removeItem("openTabs");
                void navigate(ROUTES.DASHBOARD);
              } else {
                const prevTabs = (activeIdTabs[index - 1] ||
                  activeIdTabs[index + 1]) as ReserveBusTab;
                if (
                  prevTabs &&
                  prevTabs.type === "reservebus" &&
                  prevTabs.reserveBusId
                ) {
                  void navigate(
                    generatePath(ROUTES.RESERVEBUS, {
                      vehicleUuid: prevTabs.reserveBusId,
                    }),
                  );
                }
              }
            }
            setActiveIdTabs((prevArr: any) => {
              prevArr.splice(index, 1);
              return Array.from(prevArr);
            });
          }}
        >
          <CloseOutline18Icon marginLeft="4px" />
        </CrossButton>
      </ButtonTextContainer>
    </TabElement>
  );
};
